import React from "react";
import "./ui-pending.scss";

export interface TextAreaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  size?: "sm" | "md";
}

/** Multi-line text input styled like src/ui TextInput (design-system candidate). */
export const TextArea = React.forwardRef<HTMLTextAreaElement, TextAreaProps>(
  ({ size = "md", className, ...rest }, ref) => (
    <textarea
      ref={ref}
      className={["ds-input", "dops-textarea", size === "sm" && "ds-input--sm", className]
        .filter(Boolean)
        .join(" ")}
      {...rest}
    />
  )
);
TextArea.displayName = "TextArea";

export default TextArea;
